import * as React from "react";
const SvgBlueTool = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#ace6f9", stroke: "#1198ff", strokeLinecap: "round", strokeLinejoin: "round", d: "M13.681 4.438A3.993 3.993 0 0 1 8.07 9.501l-3.506 4.062a1.503 1.503 0 0 1-2.125-2.125L6.5 7.932a3.994 3.994 0 0 1 5.063-5.613L8.938 4.94l.356 1.768 1.769.356z", style: {
  fill: "#ace6f9",
  fill: "color(display-p3 .6745 .902 .9765)",
  fillOpacity: 1,
  stroke: "#1198ff",
  stroke: "color(display-p3 .0667 .5961 1)",
  strokeOpacity: 1
} }));
export default SvgBlueTool;
